var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-app":""}},[_c('Loader'),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('FlashMessage',{attrs:{"position":'right top'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }